import './company.css';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import { useState, useEffect} from "react";

export const Company = () => {
  const [topMessage, setTopMessage] = useState<number>(1);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTopMessage((prevPage) => 0);
    }, 10000);

    return () => clearInterval(intervalId); 
  }, []); 

  return (
    <>
      <Header />
      <main>
        <div className='contents-title-box'>
          <h3>会社概要</h3>
        </div>
        <div className='company-info-list-box'>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>会社名</h4>
            </div>
            <div className='company-info-value'>
              <p>有限会社 野村製作所</p>
            </div>
          </div>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>英語表記</h4>
            </div>
            <div className='company-info-value'>
              <p>NOMURA SEISAKUSHO CO., LTD.</p>
            </div>
          </div>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>代表者</h4>
            </div>
            <div className='company-info-value'>
              <p>野村 俊一（代表取締役）</p>
            </div>
          </div>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>本社所在地</h4>
            </div>
            <div className='company-info-value'>
              <p>〒110-0015 東京都台東区東上野1-28-10</p>
              <p>メゾン野村2階(<a href='https://maps.app.goo.gl/dmcRwxcgrjsu4nji8' target="_blank" rel="noopener">地図アプリ</a>)</p>
            </div>
          </div>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>電話番号</h4>
            </div>
            <div className='company-info-value'>
              <p>03-3837-2314</p>
            </div>
          </div>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>FAX番号</h4>
            </div>
            <div className='company-info-value'>
              <p>03-3837-1438</p>
            </div>
          </div>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>営業時間</h4>
            </div>
            <div className='company-info-value'>
              <p>9:00～18:00 土日、祝日休業 (のむのもの。店舗は11:00～17:00 詳細は下記参照) </p>
            </div>
          </div>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>資本金</h4>
            </div>
            <div className='company-info-value'>
              <p>4,000,000円</p>
            </div>
          </div>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>取り扱い商品</h4>
            </div>
            <div className='company-info-value'>
              <p>革袋物製品（財布、ポーチ、ペンケース、ブックカバー、ノベルティ等）</p>
            </div>
          </div>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>主要取引先</h4>
            </div>
            <div className='company-info-value'>
              <p>大手アパレルブランド</p>
            </div>
          </div>
          <div className='company-info-list'>
            <div className='company-info-key'>
              <h4>所属組合</h4>
            </div>
            <div className='company-info-value'>
              <p>一般社団法人日本バッグ協会</p>
              <p>日本鞄ハンドバッグ協会</p>
              <p>日本バッグ工業連合会</p>
              <p>東日本バッグ工業組合</p>
            </div>
          </div>
        </div>
        <div className='contents-title-box'>
          <h3>店舗情報</h3>
        </div>
        <div className='shop-info-box'>
          <div className='shop-list'>
            <img src='img/nomunomono-shop.jpg' />
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>店舗名</h4>
              </div>
              <div className='company-info-value'>
                <p>のむのもの。</p>
              </div>
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>所在地</h4>
              </div>
              <div className='company-info-value'>
                <p>〒110-0015</p>
                <p>東京都台東区東上野1-28-10</p>
                <p>メゾン野村1階(<a href='https://maps.app.goo.gl/dmcRwxcgrjsu4nji8' target="_blank" rel="noopener">地図アプリ</a>)</p>
              </div>
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>電話番号</h4>
              </div>
              <div className='company-info-value'>
                <p>03-3837-2314</p>
              </div>
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>営業時間</h4>
              </div>
              <div className='company-info-value'>
                <p>11:00～17:00 土日、祝日休業 <br/>月に1～２回、土日を営業いたします。</p>
              </div>
              
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>その他</h4>
              </div>
              <div className='company-info-value-other'>
                <img src='img/nomunomono-insta.jpg' />
                <p><a href='https://www.instagram.com/nomuraseisakusho_official/' target="_blank" rel="noopener" >instagram</a>公開中</p>
              </div>
            </div>
          </div>
          <div className='shop-list'>
            <img src='img/CROCCO603.jpg' />
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>店舗名</h4>
              </div>
              <div className='company-info-value'>
                <p>CROCCO603</p>
              </div>
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>所在地</h4>
              </div>
              <div className='company-info-value'>
                <p>〒110-0015</p>
                <p>東京都台東区東上野1-28-10</p>
                <p>メゾン野村603号室(<a href='https://maps.app.goo.gl/dmcRwxcgrjsu4nji8' target="_blank" rel="noopener">地図アプリ</a>)</p>
              </div>
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>電話番号</h4>
              </div>
              <div className='company-info-value'>
                <p>03-3837-2314</p>
              </div>
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>営業時間</h4>
              </div>
              <div className='company-info-value'>
                <p>11:00～17:00 土日、祝日休業<br/>要予約</p>
              </div>
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>その他</h4>
              </div>
              <div className='company-info-value-other'>
                <img src='img/QR_CROCCOinsta.jpg' />
                <p><a href='https://www.instagram.com/crocco_tokyo/' target="_blank" rel="noopener" >instagram</a>公開中</p>
              </div>
            </div>
          </div>
                  <div className='shop-list'>
            <img src='img/company_img_tochigi.jpg' />
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>店舗名</h4>
              </div>
              <div className='company-info-value'>
                <p>栃木営業所</p>
              </div>
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>所在地</h4>
              </div>
              <div className='company-info-value'>
                <p>〒329-4411</p>
                <p>栃木県栃木市大平町横堀526-1</p>
                <p>(<a href='https://maps.app.goo.gl/bAXtHiJknrDw7UrR6'target="_blank" rel="noopener">地図アプリ</a>)</p>
              </div>
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>電話番号</h4>
              </div>
              <div className='company-info-value'>
                <p>0282-25-7368</p>
              </div>
            </div>
            <div className='company-info-list'>
              <div className='company-info-key'>
                <h4>営業時間</h4>
              </div>
              <div className='company-info-value'>
                <p>10:00～16:00<br/> 水曜 ～ 金曜 </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};
